import { render, staticRenderFns } from "./ClassesTable.vue?vue&type=template&id=1e65ec74&scoped=true&lang=pug&"
import script from "./ClassesTable.vue?vue&type=script&lang=ts&"
export * from "./ClassesTable.vue?vue&type=script&lang=ts&"
import style0 from "./ClassesTable.vue?vue&type=style&index=0&id=1e65ec74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65ec74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAlert,VDataTable,VExpandTransition})
